let preloaderState = {}

const initSimplePreloader = (obj) => {
  Object.keys(obj).forEach(elem => (obj[elem] = false));
  preloaderState = obj;
};

//Register the objects on page-level

const checkAndRemoveSimplePreloader = (preLoaderProp) => {
  preloaderState[preLoaderProp] = true;
  const allTrue = Object.values(preloaderState).every(item => item);
  if (allTrue) {
    document.querySelector('body').style.opacity = '1';
  }
};

const getPreloaderState = () => {
  return preloaderState;
}

export {
  initSimplePreloader,
  checkAndRemoveSimplePreloader,
  getPreloaderState,
};